<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.fixHeightScrollable {
  overflow: auto;
  height: 500px;
}
label {
  width: 100%;
  padding-bottom: 0px;
  margin-bottom: 0px;
  float: none;
}
.dx-field-value{
	float: none;
  width: 100%;
}
</style>

<template>
    <div>
      <DxForm
        id="form-mud"
        :form-data="mudData"
        label-mode="outside"
        label-location="top"
        :show-colon-after-label="true"
        col-count="3"/>
        <div>
        <div class="d-flex justify-content-between">
          <h4>Mud</h4>
          <div>
            <DxButton
              icon="download"
              hint="Download Mud excel file"
              :height="40"
              />
            <DxButton
              id="refreshButton"
              icon="revert"
              hint="Refresh"
              :height="40"
              @click="init" />
          </div>
        </div>
        <br />
          <hr />
          <div class="d-flex justify-content-between">
            <div class="d-flex" @click='mudPropData.collapsed = !mudPropData.collapsed'>
              <h5 align="left"> 
              
              <span>
                <b-icon v-show="!mudPropData.collapsed" icon="chevron-bar-contract" class="show-content" />
                <b-icon v-show="mudPropData.collapsed" icon="chevron-bar-expand" class="hide-content" />
              </span>
                Mud Properties 
              </h5>
              <span>
                <b-icon v-show="mudPropData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!mudPropData.mandatory" icon="exclamation-circle" variant="danger" />
              </span>
            </div>
            <div v-show="false">
              <span class="border border-primary p-1">
                <b-icon v-show="mudPropData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!mudPropData.mandatory" icon="exclamation-circle" variant="danger" />
                Mandatory data
              </span>
            </div>
          </div>
          <div v-show="!mudPropData.collapsed" class="overflow-auto">
            <DxDataGrid
              id="property-grid"
              ref="propertyGrid"
              :data-source="mudPropertiesDataSource"
              :show-borders="false"
              :show-column-lines="false"
              :show-row-lines="true"
              column-resize-mode="nextColumn"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :cell-hint-enabled="true"
              :word-wrap-enabled="true"
              :column-auto-width="false"
              :column-width="100"
              :height="300"
              @saved="saveProperties"
              @row-removed="onRowRemoved"
            >
              <DxPaging :enabled="false"/>
              <DxSelection mode="single"/>
              <DxScrolling column-rendering-mode="standard"/>
              <DxEditing
                  :allow-updating="editable"
                  :allow-adding="editable"
                  :allow-deleting="editable"
                  :use-icons="true"
                  mode="popup"/>
                  <DxPopup
                    :show-title="true"
                    :width="700"
                    :height="500"
                    title="Mud Properties">
                    <DxForm>
                      <DxItem
                        item-type="group"
                      >
                      <DxItem data-field="name" data-type="string" caption="Mud Name"/>
                        <DxItem data-field="type" data-type="string" caption="Mud Type">
                          <DxLookup 
                            :data-source="optionMudTypes"
                            value-expr="value"
                            display-expr="text"
                          />
                        </DxItem>
                        <DxItem data-field="reportedTime" data-type="string" caption="Time"/>
                        <DxItem data-field="drillingActivity" data-type="string" caption="Drilling Activity"/>
                        <DxItem data-field="tempIn" data-type="number" caption="Temp. In"/>
                        <DxItem data-field="tempOut" data-type="number" caption="Temp. Out"/>
                        <DxItem data-field="mwIn" data-type="number" caption="MW In"/>
                        <DxItem data-field="mwOut" data-type="number" caption="MW Out"/>
                        <DxItem data-field="funvis" data-type="number" caption="FUN VIS"/>
                        <DxItem data-field="pv" data-type="number" caption="PV"/>
                        <DxItem data-field="yp" data-type="number" caption="YP"/>
                        <DxItem data-field="tenSecGels" data-type="number" caption="10 second Gels"/>
                        <DxItem data-field="tenMinGels" data-type="number" caption="10 minute Gels"/>
                        <DxItem data-field="thirtyMinGels" data-type="number" caption="30 minute Gels"/>
                        <DxItem data-field="fluidLoss" data-type="number" caption="Fluid Loss"/>
                        <DxItem data-field="hphtFluidLoss" data-type="number" caption="HPHT Fluid Loss"/>
                        <DxItem data-field="cake" data-type="number" caption="Cake"/>
                        <DxItem data-field="sand" data-type="number" caption="Sand"/>
                        <DxItem data-field="solids" data-type="number" caption="Solids"/>
                        <DxItem data-field="ratioHGStoLGS" data-type="number" caption="HGS/LGS"/>
                        <DxItem data-field="oil" data-type="number" caption="Oil"/>
                        <DxItem data-field="water" data-type="number" caption="H2O"/>
                        <DxItem data-field="mbt" data-type="number" caption="MBT"/>
                        <DxItem data-field="pH" data-type="number" caption="pH"/>
                        <DxItem data-field="pM" data-type="number" caption="PM"/>
                        <DxItem data-field="ratioPftoMf" data-type="number" caption="Pf/Mf"/>
                        <DxItem data-field="naCl" data-type="number" caption="NaCl"/>
                        <DxItem data-field="kPlus" data-type="number" caption="K+"/>
                        <DxItem data-field="cl" data-type="number" caption="Cl"/>
                        <DxItem data-field="caPlus" data-type="number" caption="Ca+"/>
                        <DxItem data-field="lime" data-type="number" caption="LIME"/>
                        <DxItem data-field="caCl2" data-type="number" caption="CaCl2"/>
                        <DxItem data-field="ratioOiltoWater" data-type="number" caption="Oil/H2O"/>
                        <DxItem data-field="comments" data-type="string" caption="Comments"/>              
                      </DxItem>
                    </DxForm>
                  </DxPopup>
            <DxColumn
              type="buttons"
              width="70"
            >
              <GridButton name="edit"/>
              <GridButton name="delete"/>
            </DxColumn>
            <DxColumn caption="No." cell-template="rowNoTemplate" width="50" >
              <DxFormItem :visible="false"/>
            </DxColumn>
            <template #rowNoTemplate="{ data }">
              {{ data.rowIndex + 1 }}
            </template>

              <DxColumn data-field="name" data-type="string" caption="Mud Name"/>
              <DxColumn data-field="type" data-type="string" caption="Mud Type">
                <DxLookup 
                  :data-source="optionMudTypes"
                  value-expr="value"
                  display-expr="text"
                />
              </DxColumn>
              <DxColumn data-field="reportedTime" data-type="string" caption="Time"/>
              <DxColumn data-field="drillingActivity" data-type="string" caption="Drilling Activity"/>
              <DxColumn data-field="tempIn" data-type="number" caption="Temp. In"/>
              <DxColumn data-field="tempOut" data-type="number" caption="Temp. Out"/>
              <DxColumn data-field="mwIn" data-type="number" caption="MW In"/>
              <DxColumn data-field="mwOut" data-type="number" caption="MW Out"/>
              <DxColumn data-field="funvis" data-type="number" caption="FUN VIS"/>
              <DxColumn data-field="pv" data-type="number" caption="PV"/>
              <DxColumn data-field="yp" data-type="number" caption="YP"/>
              <DxColumn data-field="tenSecGels" data-type="number" caption="10 second Gels"/>
              <DxColumn data-field="tenMinGels" data-type="number" caption="10 minute Gels"/>
              <DxColumn data-field="thirtyMinGels" data-type="number" caption="30 minute Gels"/>
              <DxColumn data-field="fluidLoss" data-type="number" caption="Fluid Loss"/>
              <DxColumn data-field="hphtFluidLoss" data-type="number" caption="HPHT Fluid Loss"/>
              <DxColumn data-field="cake" data-type="number" caption="Cake"/>
              <DxColumn data-field="sand" data-type="number" caption="Sand"/>
              <DxColumn data-field="solids" data-type="number" caption="Solids"/>
              <DxColumn data-field="ratioHGStoLGS" data-type="number" caption="HGS/LGS"/>
              <DxColumn data-field="oil" data-type="number" caption="Oil"/>
              <DxColumn data-field="water" data-type="number" caption="H2O"/>
              <DxColumn data-field="mbt" data-type="number" caption="MBT"/>
              <DxColumn data-field="pH" data-type="number" caption="pH"/>
              <DxColumn data-field="pM" data-type="number" caption="PM"/>
              <DxColumn data-field="ratioPftoMf" data-type="number" caption="Pf/Mf"/>
              <DxColumn data-field="naCl" data-type="number" caption="NaCl"/>
              <DxColumn data-field="kPlus" data-type="number" caption="K+"/>
              <DxColumn data-field="cl" data-type="number" caption="Cl"/>
              <DxColumn data-field="caPlus" data-type="number" caption="Ca+"/>
              <DxColumn data-field="lime" data-type="number" caption="LIME"/>
              <DxColumn data-field="caCl2" data-type="number" caption="CaCl2"/>
              <DxColumn data-field="ratioOiltoWater" data-type="number" caption="Oil/H2O"/>
              <DxColumn data-field="comments" data-type="string" caption="Comments"/>              
            </DxDataGrid>
          </div>
          <hr />
          <div class="d-flex justify-content-between">
            <div class="d-flex" @click='sceData.collapsed = !sceData.collapsed'>
              <h5 align="left">
               
              <span>
                <b-icon v-show="!sceData.collapsed" icon="chevron-bar-contract" class="show-content" />
                <b-icon v-show="sceData.collapsed" icon="chevron-bar-expand" class="hide-content" />
              </span>
              Solid Control Equipment (SCE)
              </h5>
              <span>
                <b-icon v-show="sceData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!sceData.mandatory" icon="exclamation-circle" variant="danger" />
              </span>
            </div>
            <div v-show="false">
              <span class="border border-primary p-1">
                <b-icon v-show="sceData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!sceData.mandatory" icon="exclamation-circle" variant="danger" />
                Mandatory data
              </span>
            </div>
          </div>
          <div v-show="!sceData.collapsed" class="overflow-auto">
            <DxDataGrid
              id="sce-grid"
              ref="sceGrid"
              :data-source="mudSceDataSource"
              :show-borders="false"
              :show-column-lines="false"
              :show-row-lines="true"
              column-resize-mode="nextColumn"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :cell-hint-enabled="true"
              :word-wrap-enabled="true"
              :column-auto-width="false"
              :column-width="100"
              :height="300"
              @saved="saveSce"
              @row-removed="onRowRemoved"
            >
              <DxPaging :enabled="false"/>
              <DxSelection mode="single"/>
              <DxEditing
                  :allow-updating="editable"
                  :allow-adding="editable"
                  :allow-deleting="editable"
                  :use-icons="true"
                  mode="row"/>
            <DxColumn
              type="buttons"
              width="70"
            >
              <GridButton name="edit"/>
              <GridButton name="delete"/>
            </DxColumn>
            <DxColumn caption="No." cell-template="rowNoTemplate" width="50" :read-only="true"/>
            <template #rowNoTemplate="{ data }">
              {{ data.rowIndex + 1 }}
            </template>
              <DxColumn data-field="sceName" data-type="string" caption="Name"/>
              <DxColumn data-field="sceModel" data-type="string" caption="Model"/>
              <DxColumn data-field="screenSize" data-type="string" caption="Screen Size"/>
              <DxColumn data-field="workingHours" data-type="number" caption="Working Hours"/>
            </DxDataGrid>
          </div>
          <hr />
        </div>

          <div class="d-flex justify-content-between">
          <div class="d-flex justify-content-between">
            <div class="d-flex" @click='adData.collapsed = !adData.collapsed'>
              <h5 align="left">
              
              <span>
                <b-icon v-show="!adData.collapsed" icon="chevron-bar-contract" class="show-content" />
                <b-icon v-show="adData.collapsed" icon="chevron-bar-expand" class="hide-content" />
              </span>
                Aerated Drilling
              </h5>
              <span>
                <b-icon v-show="adData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!adData.mandatory" icon="exclamation-circle" variant="danger" />
              </span>
            </div>
            <div v-show="false">
              <span class="border border-primary p-1">
                <b-icon v-show="adData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!adData.mandatory" icon="exclamation-circle" variant="danger" />
                Mandatory data
              </span>
              
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <div style="text-align: end">
                <b-button-group v-if="editable">
                  <DxButton
                    :width="40"
                    icon="save"
                    hint="Submit" 
                    styling-mode="outlined"
                    @click="saveMud"/>
                </b-button-group>
            </div>
          </div>
        </div>
          <div v-show="!adData.collapsed" class="overflow-auto">
            <DxItem
              />
            <b-form-group
              id="input-group-average-air-rate"
              label="Avg. Air Rate:"
              label-for="input-average-air-rate"
            >
              <b-form-input
                id="input-average-air-rate"
                v-model="mudData.avgAirRate"
                type="text"
                placeholder="Enter average air rate"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-avg-foam-rate"
              label="Avg. Foam Rate"
              label-for="input-avg-foam-rate"
            >
              <b-form-input
                id="input-avg-foam-rate"
                v-model="mudData.avgFoamRate"
                type="text"
                placeholder="Enter average foam rate"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-avg-corrosion-inhibitor-rate"
              label="Avg. Corrosion Inhibitor Rate:"
              label-for="input-avg-corrosion-inhibitor-rate"
            >
              <b-form-input
                id="input-avg-corrosion-inhibitor-rate"
                v-model="mudData.avgCorr"
                type="text"
                placeholder="Enter average corrosion inhibitor rate"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <DxDataGrid
              id="additive-grid"
              ref="additiveGrid"
              :data-source="mudAdditiveDataSource"
              :show-borders="false"
              :show-column-lines="false"
              :show-row-lines="true"
              column-resize-mode="nextColumn"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :cell-hint-enabled="true"
              :word-wrap-enabled="true"
              :column-auto-width="false"
              :column-width="100"
              :height="300"
              @saved="saveAdditive"
              @row-removed="onRowRemoved"
            >
              <DxPaging :enabled="false"/>
              <DxSelection mode="single"/>
              <DxEditing
                  :allow-updating="editable"
                  :allow-adding="editable"
                  :allow-deleting="editable"
                  :use-icons="true"
                  mode="row"/>
            <DxColumn
              type="buttons"
              width="5%"
            >
              <GridButton name="edit"/>
              <GridButton name="delete"/>
            </DxColumn>
            <DxColumn caption="No." cell-template="rowNoTemplate" width="5%" />
            <template #rowNoTemplate="{ data }">
              {{ data.rowIndex + 1 }}
            </template>

              <DxColumn data-field="otherAdditive" data-type="string" caption="Other Additive"/>
              <DxColumn data-field="avgOtherAdditiveRate" data-type="string" caption="Avg. Other Additive Rate"/>
            </DxDataGrid>
            <b-form-group
              id="input-group-remark"
              label="Remarks:"
              label-for="input-remark"
              class="w-100"
            >
              <b-form-textarea
                id="input-remark"
                v-model="mudData.remarks"
                rows="5"
                placeholder="Enter remarks"
                :disabled="!editable"
              ></b-form-textarea>
            </b-form-group>
          </div>
        <hr />
        <div class="d-flex justify-content-between">
          <div class="d-flex" @click='mudVolumeData.collapsed = !mudVolumeData.collapsed'>
            <h5 align="left">
            <span>
                <b-icon v-show="!mudVolumeData.collapsed" icon="chevron-bar-contract" class="show-content" />
                <b-icon v-show="mudVolumeData.collapsed" icon="chevron-bar-expand" class="hide-content" />
              </span>            
              Mud Volume
            </h5>
            <span>
                <b-icon v-show="mudVolumeData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!mudVolumeData.mandatory" icon="exclamation-circle" variant="danger" />
              </span>
          </div>
            <div v-show="false">
              <span class="border border-primary p-1">
                <b-icon v-show="mudVolumeData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!mudVolumeData.mandatory" icon="exclamation-circle" variant="danger" />
                Mandatory data
              </span>
            </div>
          </div>
          <div v-show="!mudVolumeData.collapsed" class="overflow-auto">
            <div class="d-flex justify-content-between">
            <div style="text-align: end">
              <b-button-group v-if="editable">
                <DxButton
                  :width="40"
                  icon="save"
                  hint="Submit" 
                  styling-mode="outlined"
                  @click="saveMud"/>
              </b-button-group>
            </div>
            </div>
            <b-form-group
              id="input-group-start"
              label="Start:"
              label-for="input-start"
            >
              <b-form-input
                  id="input-start"
                  v-model="mudData.start"
                  type="number"
                  step="0.001"
                  placeholder="Enter DP"
                  :disabled="!editable"
                ></b-form-input>
              </b-form-group>
            <b-form-group
              id="input-group-dailyLost"
              label="Lost Downhole:"
              label-for="input-dailyLost"
            >
              <b-form-input
                id="input-dailyLost"
                v-model="mudData.lostDownhole"
                type="number"
                step="0.001"
                placeholder="Enter Daily Lost"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-lost-surface"
              label="Lost Surface:"
              label-for="input-lost-surface"
            >
              <b-form-input
                id="input-lost-surface"
                v-model="mudData.lostSurface"
                type="number"
                step="0.001"
                placeholder="Enter lost on surface"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-built"
              label="Built:"
              label-for="input-built"
            >
              <b-form-input
                id="input-built"
                v-model="mudData.built"
                type="number"
                step="0.001"
                placeholder="Enter built"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-dumped"
              label="Dumped:"
              label-for="input-dumped"
            >
              <b-form-input
                id="input-dumoed"
                v-model="mudData.dumped"
                type="number"
                step="0.001"
                placeholder="Enter dumped"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-ending"
              label="Ending:"
              label-for="input-ending"
            >
              <b-form-input
                id="input-ending"
                v-model="mudData.ending"
                type="number"
                step="0.001"
                placeholder="Enter ending"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
          </div>
          <hr />
          <div class="d-flex justify-content-between">
            <div class="d-flex" @click='gcData.collapsed = !gcData.collapsed'>
              <h5 align="left">
              <span>
                <b-icon v-show="!gcData.collapsed" icon="chevron-bar-contract" class="show-content" />
                <b-icon v-show="gcData.collapsed" icon="chevron-bar-expand" class="hide-content" />
              </span>
              Gas Content
              </h5>
              <span>
                <b-icon v-show="gcData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!gcData.mandatory" icon="exclamation-circle" variant="danger" />
              </span>
            </div>
            <div v-show="false">
              <span class="border border-primary p-1">
                <b-icon v-show="gcData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!gcData.mandatory" icon="exclamation-circle" variant="danger" />
                Mandatory data
              </span>
              
            </div>
          </div>
          <div v-show="!gcData.collapsed" class="overflow-auto">
            <div class="d-flex justify-content-between">
            <div style="text-align: end">
              <b-button-group v-if="editable">
                <DxButton
                  :width="40"
                  icon="save"
                  hint="Submit" 
                  styling-mode="outlined"
                  @click="saveMud"/>
              </b-button-group>
            </div>
            </div>
            <b-form-group
              id="input-group-bcg"
              label="Max. Background Gas:"
              label-for="input-bcg"
            >
              <b-form-input
                id="input-bcg"
                v-model="mudData.maxBgGas"
                type="number"
                step="0.001"
                placeholder="Enter maximum background gas"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-cg"
              label="Max. Connection Gas:"
              label-for="input-cg"
            >
              <b-form-input
                id="input-cg"
                v-model="mudData.maxConnGas"
                type="number"
                step="0.001"
                placeholder="Enter maximum connection gas"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-tripGas"
              label="Trip Gas:"
              label-for="input-tripGas"
            >
              <b-form-input
                id="input-tripGas"
                v-model="mudData.maxTripGas"
                type="number"
                step="0.001"
                placeholder="Enter Trip Gas"
                :disabled="!editable"
              ></b-form-input>
            </b-form-group>
        </div>
        <hr />
          <div class="d-flex justify-content-between">
            <div class="d-flex" @click='lcData.collapsed = !lcData.collapsed'>
              <h5 align="left">
              <span>
                <b-icon v-show="!lcData.collapsed" icon="chevron-bar-contract" class="show-content" />
                <b-icon v-show="lcData.collapsed" icon="chevron-bar-expand" class="hide-content" />
              </span>
              Lost Circulation
              </h5>
              <span>
                <b-icon v-show="lcData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!lcData.mandatory" icon="exclamation-circle" variant="danger" />
              </span>
            </div>
            <div v-show="false">
              <span class="border border-primary p-1">
                <b-icon v-show="lcData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!lcData.mandatory" icon="exclamation-circle" variant="danger" />
                Mandatory data
              </span>              
            </div>
          </div>
          <div v-show="!lcData.collapsed" class="overflow-auto">          
            <DxDataGrid
              id="lost-circulation-grid"
              ref="lostCirculationGrid"
              :data-source="lostCirculationDataSource"
              :show-borders="false"
              :show-column-lines="false"
              :show-row-lines="true"
              column-resize-mode="nextColumn"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :cell-hint-enabled="true"
              :word-wrap-enabled="true"
              :column-auto-width="false"
              :column-width="100"
              :height="400"
              @saved="saveLostCirculation"
              @row-removed="onRowRemoved"
            >
              <DxPaging :enabled="false"/>
              <DxSelection mode="single"/>
              <DxEditing
                  :allow-updating="editable"
                  :allow-adding="editable"
                  :allow-deleting="editable"
                  :use-icons="true"
                  col-count="3"
                  mode="form"/>
                  <!--DxForm col-span="2">
                    <DxGroupItem caption="Depth Range">
                      <DxSimpleItem data-field="depthRangeMin" editorType="dxNumberBox">
                        <DxLabel text="Min" :show-colon="true" location="top" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="depthRangeMax" editorType="dxNumberBox">
                        <DxLabel text="Max" :show-colon="true" location="top" />
                      </DxSimpleItem>
                    </DxGroupItem>
                    <DxGroupItem caption="Loss Rate">
                      <DxSimpleItem data-field="lossRateMin" editorType="dxNumberBox">
                        <DxLabel text="Min" :show-colon="true" location="top" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="lossRateMax" editorType="dxNumberBox">
                        <DxLabel text="Max" :show-colon="true" location="top" />
                      </DxSimpleItem>
                    </DxGroupItem>
                    <DxSimpleItem data-field="mitigationAction" editorType="dxNumberBox">
                      <DxLabel text="Mitigation Action" :show-colon="true" location="top"/>
                    </DxSimpleItem>
                    <DxSimpleItem data-field="result" editorType="dxNumberBox">
                      <DxLabel text="Result" :show-colon="true" location="top"/>
                    </DxSimpleItem>
                    <DxSimpleItem data-field="nextPlan" editorType="dxNumberBox">
                      <DxLabel text="Next Plan" :show-colon="true" location="top"/>
                    </DxSimpleItem>
                  </DxForm>
              </DxEditing-->
            <DxColumn
              type="buttons"
              width="70"
            >
              <GridButton name="edit"/>
              <GridButton name="delete"/>
            </DxColumn>
            <DxColumn caption="No." cell-template="rowNoTemplate" width="50" >
              <DxFormItem :visible="false" />
            </DxColumn>
            <template #rowNoTemplate="{ data }">
              {{ data.rowIndex + 1 }}
            </template>

              <DxColumn caption="Depth Range" :calculate-cell-value="composeDepthRange">
                <DxFormItem :visible="false" />
              </DxColumn>
              <DxColumn :visible="false" data-field="depthRangeMin" data-type="number" caption="Depth Range Min">
                <DxFormItem :visible="true" />
              </DxColumn>
              <DxColumn :visible="false" data-field="depthRangeMax" data-type="number" caption="Depth Range Max">
                <DxFormItem :visible="true" />
              </DxColumn>
              <DxColumn caption="Loss Rate" :calculate-cell-value="composeLossRate">
                <DxFormItem :visible="false"/>
              </DxColumn>
              <DxColumn :visible="false" data-field="lossRateMin" data-type="number" caption="Loss Rate Min">
                <DxFormItem :visible="true" />
              </DxColumn>
              <DxColumn :visible="false" data-field="lossRateMax" data-type="number" caption="Loss Rate Max">
                <DxFormItem :visible="true" />
              </DxColumn>
              <DxColumn data-field="mitigationAction" data-type="string" caption="Mitigation Action"/>
              <DxColumn data-field="result" data-type="string" caption="Result"/>
              <DxColumn data-field="nextPlan" data-type="string" caption="Next Plan"/>
            </DxDataGrid>
        </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods, formComputed, authComputed } from '@state/helpers'
import axios from 'axios'
import qs from 'querystring'
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxSelection,
  DxLookup,
  DxScrolling,
  DxPopup,
  DxItem,
  DxFormItem,
  DxForm,
  DxButton as GridButton
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import DxButton from 'devextreme-vue/button'
import mapApiUrl from '@/src/utils/api-mapper'
import CustomStore from 'devextreme/data/custom_store'
import { DxTextArea } from 'devextreme-vue/text-area'

Vue.use(VueFormGenerator)

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing, 
    DxSelection,
    DxLookup,
    DxScrolling,
    DxPopup,
    DxItem,
    DxFormItem,
    DxForm,
    DxButton,
    DxTextArea,
    GridButton
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {
      type: Number,
      default: 0,
    },
    editable: Boolean,
    wellId: {
      type: Number,
      default: 0,
    },
    lastSubmitId: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      sourceSubmitId: 0,
      mudPropertiesData: [],
      mudSceData: [],
      mudAdditiveData: [],
      lostCirculationData: [],
      mudPropertiesDataSource: [],
      mudSceDataSource: [],
      mudAdditiveDataSource: [],
      lostCirculationDataSource: [],
      mudData: [],
      forms: [],
      currentForm: [],
      selectedRow: [],
      selectedAction: '',
      reportIsLoading: false,
      show: true,
      hasData: false,
      editableOps: this.editable,
      mudId: null,
      optionMudTypes: [
        { text: "Mud", value:"MUD" },
        { text: "Water", value: "WATER" },
        { text: "Hivis", value: "HIVIS" }
        ],
      mudPropData: {collapsed: true, mandatory: true},
      adData: {collapsed: true, mandatory: true},
      sceData: {collapsed: true, mandatory: true},
      mudVolumeData: {collapsed: true, mandatory: true},
      gcData: {collapsed: true, mandatory: true},
      lcData: {collapsed: true, mandatory: true},
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
    }
  },
  computed: {
    ...formComputed,
    ...authComputed,
  },
  watch: {
    submitId: function (value) {
      this.refreshMud()
      this.refreshGrids()
    },
    editable: function (val) {
      this.editableOps = val
    },
    mudId: function(val) {
      this.refreshGrids()
    } 
  },
  created: function () {
    this.refreshMud()
    this.init()
  },
  methods: {
    ...formMethods,
    refreshGrids() {
      /* this.mudPropertiesDataSource.load()
      this.mudAdditiveDataSource.load()
      this.mudSceDataSource.load()
      this.lostCirculationDataSource.load() */
      this.$refs.propertyGrid.instance.refresh()
      this.$refs.sceGrid.instance.refresh()
      this.$refs.additiveGrid.instance.refresh()
      this.$refs.lostCirculationGrid.instance.refresh()
    }, 
    onRowRemoved(e) {
      notify({ message: 'Data has been deleted.', width: 500 }, 'success', 3000)
    },
    onRowRemovingProperties(e) {
      this.reportIsLoading = true
      axios.delete(
        mapApiUrl("/api/form/master/mud/properties/delete"),
        {params: { id: e.data.id }})
      .then((response) => {
        this.reportIsLoading = true
        if (response.data) {
          notify({ message: 'Data has been deleted.', width: 500 }, 'success', 3000)
        } else {
          notify({ message: 'Data has NOT been deleted.', width: 300 }, 'error', 3000)
        }
      })
    },
    onRowRemovingAdditive(e) {
      axios.delete(
        mapApiUrl("/api/form/master/mud/aerated-drilling/delete"),
        {params: { id: e.data.id }})
        .then((response) => {
          if (response.data) {
            notify({ message: 'Data has been deleted.', width: 500 }, 'success', 3000)
          } else {
            notify({ message: 'Data has NOT been deleted.', width: 300 }, 'error', 3000)
          }
        })
    },
    onRowRemovingSce(e) {
        axios.delete(
          mapApiUrl("/api/form/master/mud/sce/delete"),
          {params: { id: e.data.id }})
          .then((response) => {
            if (response.data) {
              notify({ message: 'Data has been deleted.', width: 500 }, 'success', 3000)
            } else {
              notify({ message: 'Data has NOT been deleted.', width: 300 }, 'error', 3000)
            }
          })
    },
    onRowRemovingLostCirculation(e) {
        axios.delete(
          mapApiUrl("/api/form/master/mud/lost-circulation/delete"),
          {params: { id: e.data.id }})
          .then((response) => {
            if (response.data) {
              notify({ message: 'Data has been deleted.', width: 500 }, 'success', 3000)
            } else {
              notify({ message: 'Data has NOT been deleted.', width: 300 }, 'error', 3000)
            }
          })
    },
    composeDepthRange(rowData) {
      return rowData.depthRangeMin + " - " + rowData.depthRangeMax
    },
    composeLossRate(rowData) {
      return rowData.lossRateMin + " - " + rowData.lossRateMax
    },
    saveMud() {
      this.mudData.id = this.mudId
      this.mudData.submitId = this.submitId
      this.mudData.dailyReportId = this.submitId
      const url = mapApiUrl('/api/form/master/mud/add')
      axios.post(url, this.mudData).then((response) => {
        notify({ message: 'Mud data has been recorded.', width: 500 }, 'success', 3000)
      })
    }, 
    saveProperties(e) {
      notify({ message: 'Mud properties data has been recorded.', width: 500 }, 'success', 3000)
      this.$refs.propertyGrid.instance.refresh()
    }, 
    saveAdditive(e) {
      notify({ message: 'Mud aerated data has been recorded.', width: 500 }, 'success', 3000)
      this.$refs.sceGrid.instance.refresh()
    },
    saveSce(e) {
      notify({ message: 'Mud Sce data has been recorded.', width: 500 }, 'success', 3000)
      this.$refs.additiveGrid.instance.refresh()
    },
    saveLostCirculation(e) {
      notify({ message: 'Mud Lost Circulation data has been recorded.', width: 500 }, 'success', 3000)
      this.$refs.lostCirculationGrid.instance.refresh()
    },
    getMudPropertiesCarryOver() {
      this.mudPropertiesData = []
      const url = mapApiUrl('/api/form/master/mud/properties/list')
      let params={submitId: this.lastSubmitId}
      this.reportIsLoading = true
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
        this.reportIsLoading = false
        if (response.data !== undefined)
        this.mudPropertiesData = response.data
      })
    },
    refreshMud() {
      this.mudData = []
      const url = mapApiUrl('/api/form/master/mud/get')
      let params={submitId: this.submitId}
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
        this.mudData = response.data
        this.mudId = response.data.id
      })      
    },
    onRowSelected(items) {
      this.selectedRow = []
      if (items.length > 0) {
        this.selectedRow = items
        this.form = items[0]
      }
    },
    onSubmit(evt) {
      evt.preventDefault()
      if (this.currentForm.pv === undefined) this.currentForm.pv = ""
      if (this.currentForm.yp === undefined) this.currentForm.yp = ""

        this.currentForm.pvYp = this.currentForm.pv + " / " + this.currentForm.yp
        delete this.currentForm.pv
        delete this.currentForm.yp

      if (this.hasData) {
        // if intId is exist that means data has already at server
        // time to update
        const data = { ...this.currentForm }
        this.updateMasterMud({ params: data }).then((resp) => {
          this.makeToast('Update mud data success.')
          this.refreshTableMud()
        })
      } else {
        // time to insert
        const data = { ...this.currentForm, submitId: this.submitId }
        this.addMasterMud({ params: data }).then((resp) => {
          this.makeToast('Add mud data success.')
          this.refreshTableMud()
        })
      }
      this.$bvModal.hide('modal-form-mud-properties')
    },
    init() {
      this.mudPropertiesDataSource = new CustomStore({
        key: 'id',
        load: () => {
          if (this.mudId === null) return
          const url = mapApiUrl('/api/form/master/mud/properties/list')
          return fetch(url + `?mudId=${this.mudId}`, {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => response.json())
            .catch(() => { throw new Error('Network error') })
        },
        onLoaded: function(result) {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0]);
            }
        },
        insert: (values) => {
          values.mudId = this.mudId
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/mud/properties/add')
          return axios.post(url, values).then(response => response)
        },
        update: (key, values) => {
          values.id = key
          values.mudId = this.mudId
          const url = mapApiUrl('/api/form/master/mud/properties/add')
          return axios.post(url, values).then(response => response)
        },
        remove: (key) => {
        const url = mapApiUrl('/api/form/master/mud/properties/delete')
          return fetch(url + `?id=${key}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => { 
                if (!response.ok) throw new Error('Network error') })
        }
      })
      this.mudSceDataSource = new CustomStore({
        key: 'id',
        load: () => {
          if (this.mudId === null) return
          const url = mapApiUrl('/api/form/master/mud/sce/list')
          return fetch(url + `?mudId=${this.mudId}`, {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => response.json())
            .catch(() => { throw new Error('Network error') })
        },
        onLoaded: function(result) {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0]);
            }
        },
        insert: (values) => {
          values.mudId = this.mudId
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/mud/sce/add')
          return axios.post(url, qs.stringify(values)).then(response => response)
        },
        update: (key, values) => {
          values.id = key
          values.mudId = this.mudId
          const url = mapApiUrl('/api/form/master/mud/sce/add')
          return axios.post(url, qs.stringify(values)).then(response => response)
        },
        remove: (key) => {
        const url = mapApiUrl('/api/form/master/mud/sce/delete')
          return fetch(url + `?id=${key}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => { 
                if (!response.ok) throw new Error('Network error') })
        },
      })
      this.mudAdditiveDataSource = new CustomStore({
        key: 'id',
        load: () => {
          if (this.mudId === null) return
          const url = mapApiUrl('/api/form/master/mud/aerated-drilling/list')
          return fetch(url + `?mudId=${this.mudId}`, {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => response.json())
            .catch(() => { throw new Error('Network error') })
        },
        onLoaded: function(result) {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0]);
            }
        },
        insert: (values) => {
          values.mudId = this.mudId
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/mud/aerated-drilling/add')
          return axios.post(url, qs.stringify(values)).then(response => response)
        },
        update: (key, values) => {
          values.id = key
          values.mudId = this.mudId
          const url = mapApiUrl('/api/form/master/mud/aerated-drilling/add')
          return axios.post(url, qs.stringify(values)).then(response => response)
        },
        remove: (key) => {
        const url = mapApiUrl('/api/form/master/mud/aerated-drilling/delete')
          return fetch(url + `?id=${key}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => { 
                if (!response.ok) throw new Error('Network error') })
        },
      })
      this.lostCirculationDataSource = new CustomStore({
        key: 'id',
        load: () => {
          if (this.mudId === null) return
          const url = mapApiUrl('/api/form/master/mud/lost-circulation/list')
          return fetch(url + `?mudId=${this.mudId}`, {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => response.json())
            .catch(() => { throw new Error('Network error') })
        },
        onLoaded: function(result) {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0]);
            }
        },
        insert: (values) => {
          values.mudId = this.mudId
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/mud/lost-circulation/add')
          return axios.post(url, qs.stringify(values)).then(response => response)
        },
        update: (key, values) => {
          values.id = key
          values.mudId = this.mudId
          const url = mapApiUrl('/api/form/master/mud/lost-circulation/add')
          return axios.post(url, qs.stringify(values)).then(response => response)
        },
        remove: (key) => {
        const url = mapApiUrl('/api/form/master/mud/lost-circulation/delete')
          return fetch(url + `?id=${key}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => { 
                if (!response.ok) throw new Error('Network error') })
        },
      })
    }
  },
}
</script>